<app-section-quick-actions section="tool" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Outfit vault</h1>
</header>

<div class="atmos-vault">
  <div class="atmos-page__intro">
    <p class="atmos-paragraph">
      On this page you can search for outfits submitted to the vault by other players.
      All outfits on this page will link to a message in the official
      <a class="atmos-text-link" href="https://discord.com/invite/thatskygame" target="_blank" rel="noopener">Sky Discord server</a>.
    </p>
    <p class="atmos-paragraph atmos-page__hint">
      <i>The outfit vault does not currently support dyes. This is a feature I want to add at some point, but it will take some time. Thank you for your patience!</i>
    </p>
  </div>

  <div class="atmos-vault__actions">
    <button type="button" class="atmos-btn atmos-btn--sm"
      [class.atmos-btn--active]="pasting()"
      (click)="pasteInput.focus(); pasting.set(true)">
      <mat-icon>content_paste</mat-icon>
      @if (pasting()) { Paste now… } @else { Paste request }
    </button>
    <input type="text" class="input-hidden" #pasteInput (paste)="paste($event)" (blur)="pasting.set(false)">
  </div>

  @switch (mode()) {
    @case ('picking') {
      <!-- Item picker -->
      <div class="atmos-card">
        <app-vault-item-picker
          [selectionInput]="selection()"
          (selectionChange)="onSelectionChange($event)">
        </app-vault-item-picker>
      </div>
    }
    @case ('results') {
      <app-vault-results
        [apiData]="resultData()"
        [currentSelection]="selection()"
        (deleteResult)="onDeleteResult($event)"
        (reportResult)="onReportResult($event)">
      </app-vault-results>
    }
    @case ('submit') {
      <app-vault-submit
        [selection]="selection()"
        [nonItems]="nonItems"
        (submitted)="onSubmitted($event)">
      </app-vault-submit>
    }
  }
</div>

<!-- Floating action buttons -->
<div class="vault-actions">
  <button type="button" class="atmos-btn atmos-btn--fab" (click)="showSubmit()" [disabled]="isSubmitting()">
    <mat-icon>add</mat-icon>
  </button>
  @if (mode() === 'picking') {
    <button type="button" class="atmos-btn atmos-btn--fab" (click)="findOutfits()" [disabled]="isFinding()">
      <mat-icon>search</mat-icon>
    </button>
  } @else {
    <button type="button" class="atmos-btn atmos-btn--fab" (click)="showPicking()" [disabled]="isFinding()">
      <mat-icon>apps</mat-icon>
    </button>
  }
</div>
